<template>
  <div class="relative font-Spectral md:px-10 e1:m-auto e1:max-w-3xl e1:p-0">
    <p class="mb-2 pt-16 text-center font-Playfair text-xs leading-3 text-gold1 md:mb-6">A Journey Designed for You</p>
    <h1 class="mb-8 px-6 text-center text-lg font-normal tracking-[0.5px] md:mb-16 md:p-0 md:text-2xl">{{ title }}</h1>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  title: string;
}
defineProps<Props>();
</script>
